// Rastgelelik kaynağı — @noble'ın cihazda dayandığı köprü (9.34 · D-616).
//
// @noble her anahtar üretimini `globalThis.crypto.getRandomValues`'a dayandırır
// ve bulamazsa atar. React Native 0.86 / Expo 57 bunu SAĞLAMAZ: Hermes'te
// `crypto` diye bir global yok. Node'da olduğu için Jest bunu göremez; şifreleme
// yığınının tamamı testte yeşil, cihazda ölüydü (D-006'nın somut hâli).
//
// Neden ayrı dosya: köprü, kripto çağıran HİÇBİR modülden önce kurulmuş olmalı.
// @noble `crypto`yu çağrı anında okuduğu için uygulama girişinde bir kez kurmak
// yetiyor — ama bu modülün importu `App`ten önce gelmek zorunda, o yüzden
// `index.js`'te en üstte duruyor.
import { getRandomValues } from 'expo-crypto';

type RastgeleGlobal = { crypto?: { getRandomValues?: unknown } };

/** Çalışma ortamında güvenli rastgelelik var mı. */
export function hasRandomSource(): boolean {
  return typeof (globalThis as RastgeleGlobal).crypto?.getRandomValues === 'function';
}

/**
 * Eksikse `crypto.getRandomValues`'ı native kaynağa bağla.
 *
 * Var olanı EZMEZ: ileride RN kendi uygulamasını getirirse platformun kendi
 * CSPRNG'si tercih edilmeli. Dönen değer köprünün kurulup kurulmadığıdır —
 * `false` "gerek yoktu" demek, "başarısız" değil; başarısızlık için
 * `hasRandomSource()` sorulur.
 */
export function installRandomSource(): boolean {
  const g = globalThis as RastgeleGlobal;
  if (hasRandomSource()) return false;

  if (g.crypto) {
    g.crypto.getRandomValues = getRandomValues;
    return true;
  }
  // Hermes'te `crypto` hiç tanımlı değil; yazılabilir bırakıyoruz ki platform
  // ya da başka bir polyfill sonradan devralabilsin.
  Object.defineProperty(g, 'crypto', {
    value: { getRandomValues },
    configurable: true,
    writable: true,
  });
  return true;
}

// Import'un KENDİSİ köprüyü kuruyor. Çağrıyı `index.js`'e bırakmak yanlış
// olurdu: ES importları hoist edilir, o yüzden oradaki bir çağrı diğer tüm
// modüller değerlendirildikten SONRA çalışırdı. Polyfill'lerin bare-import
// olmasının nedeni tam olarak bu.
installRandomSource();
